export default {
  AbuseReportInitiated: 'abuseReportInitiated',
  AbuseReportSubmit: 'abuseReportSubmit',
  AbuseReportSubmitSuccess: 'abuseReportSubmitSuccess',
  AbuseReportSubmitFailed: 'abuseReportSubmitFailed'
};
